import { createContext } from 'react';
import type { UniversalState } from '../utils/createUniversalState';

export const UniversalStateContext = createContext<UniversalState | undefined>(undefined);
